/**
 * API client da fila de produtos pendentes de cadastro
 * (Bloco E.2 v2, ADR-0019).
 *
 * Produtos sao auto-criados quando vendedor importa projeto CAD e o
 * material nao esta cadastrado no estoque. Esta tela permite o estoque
 * processar a fila: cadastrar nome, categoria, unidade, **custo_medio**,
 * estoque_minimo.
 */

const PREFIXO = "/api/produtos";

export function listarProdutosPendentes(request, params = {}) {
  const usp = new URLSearchParams();
  usp.set("pendente", "true");
  if (params.fonte_externa) usp.set("fonte_externa", params.fonte_externa);
  if (params.busca) usp.set("busca", params.busca);
  if (params.pageSize) usp.set("page_size", String(params.pageSize));
  const qs = usp.toString();
  return request(`${PREFIXO}${qs ? `?${qs}` : ""}`);
}

export function obterItemsVinculados(request, produtoId) {
  return request(`${PREFIXO}/${produtoId}/items-vinculados`);
}

export function completarProdutoPendente(request, produtoId, dados) {
  return request(`${PREFIXO}/${produtoId}/completar-pendente`, {
    method: "POST",
    body: JSON.stringify(dados),
  });
}

// Limite do backend por chamada (estoque.services.LOTE_MAXIMO_EXCLUSAO_PENDENTES).
const LOTE_EXCLUSAO = 200;

/**
 * Apaga varios produtos da fila em fatias de 200 e soma o resultado:
 * { apagados, recusados: [{codigo, nome, motivo}], resumo: {motivo: n}, nao_encontrados }.
 */
export async function excluirProdutosPendentes(request, ids) {
  const total = { apagados: 0, recusados: [], resumo: {}, nao_encontrados: 0, itens_requisicao_desvinculados: 0 };
  for (let i = 0; i < ids.length; i += LOTE_EXCLUSAO) {
    const r = await request(`${PREFIXO}/excluir-pendentes`, {
      method: "POST",
      body: JSON.stringify({ ids: ids.slice(i, i + LOTE_EXCLUSAO) }),
    });
    total.apagados += r.apagados || 0;
    total.recusados.push(...(r.recusados || []));
    total.nao_encontrados += r.nao_encontrados || 0;
    total.itens_requisicao_desvinculados += r.itens_requisicao_desvinculados || 0;
    Object.entries(r.resumo || {}).forEach(([k, n]) => { total.resumo[k] = (total.resumo[k] || 0) + n; });
  }
  return total;
}

export function baixarTemplateXLSX(request) {
  // Retorna blob para download direto
  return request(`${PREFIXO}/template-xlsx`, {
    method: "GET",
    rawResponse: true,
  });
}
